<template>
  <v-dialog v-model="visible" width="40rem" persistent scrollable>
    <v-card v-if="is_loading_main">
      <v-skeleton-loader type="card, list-item@6" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon
            icon="positions"
            class="mr-2"
            :strokewidth="3"
            fill="white"
          />
          <v-toolbar-title class="ml-1">
            Pozicija
          </v-toolbar-title>
          <template v-slot:extension>
            <v-tabs
              v-model="active_tab"
              hide-slider
              background-color="background darken"
            >
              <v-tab>Info</v-tab>
              <v-tab>Odgovornosti</v-tab>
              <v-tab>Edukacija</v-tab>
              <v-tab>Specifično</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-card-text class="pa-0 ma-0" style="height: 30rem;">
          <div class="master_grid">
            <div>
              <v-tabs-items v-model="active_tab">
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <v-text-field
                          v-model="item.position_name"
                          outlined
                          label="Naziv pozicije"
                          required
                          maxlength="100"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 pt-1 mb-3">
                        <webpage_lookup_departments
                          update="wp_department_changed"
                          :selected_id="item.department_id"
                        ></webpage_lookup_departments>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <v-text-field
                          v-model.number="item.salary_net"
                          outlined
                          label="Neto lični dohodak"
                          type="number"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 pt-1">
                        <v-textarea
                          v-model="item.job_description"
                          outlined
                          clearable
                          auto-grow
                          label="Opis posla na poziciji"
                          maxlength="2000"
                          counter
                        ></v-textarea>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item>
                  <v-card
                    class="ma-0"
                    flat
                    color="tertiary"
                    style="border-radius: 1rem;"
                  >
                    <div style="margin-left:2rem;margin-top:1rem;">
                      {{ text_responsibilities }}
                    </div>
                    <v-card-text>
                      <v-text-field
                        clearable
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        v-model="search_text"
                        label="Pretraga postojećih odgovornosti"
                        placeholder="Unesite naziv pojma za pretragu"
                        outlined
                      ></v-text-field>
                      <v-card flat v-if="is_loading">
                        <v-skeleton-loader type="table, list-item@6" />
                      </v-card>
                      <template v-else>
                        <v-data-table
                          v-model="selected_responsibilities"
                          style="background: transparent;"
                          no-data-text="Podaci ne postoje za odabranu kategoriju"
                          :search="search_text"
                          :items="responsibilities_list"
                          show-select
                          :headers="headers"
                          :options="{ itemsPerPage: 50 }"
                          :footer-props="{
                            'items-per-page-options': [10, 25, 50, -1],
                            'items-per-page-text': 'Broj zapisa po stranici',
                            'items-per-page-all-text': 'Svi',
                            'page-text': '{0}-{1} od {2}',
                          }"
                        >
                        </v-data-table>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <v-select
                          v-model="item.education"
                          class="select"
                          mandatory
                          :items="educations"
                          outlined
                          label="Edukacija"
                        ></v-select>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 pt-1">
                        <v-text-field
                          v-model="item.languages"
                          outlined
                          label="Strani jezici"
                          maxlength="100"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <v-text-field
                          v-model="item.driving_license"
                          outlined
                          label="Vozačka dozvola"
                          maxlength="45"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 pt-1">
                        <v-text-field
                          v-model="item.certificates"
                          outlined
                          label="Certifikati"
                          maxlength="255"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog()">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="is_btn_loading" text @click="save_item()"
            >Snimi</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_lookup_departments: () =>
      import("@/components/lookups/departments"),
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    close: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    is_btn_loading: false,
    selected_item: {
      id: null,
    },
    selected_responsibilities: [],
    text_responsibilities:
      "Odaberite željene odgovornosti za novu poziciju iz postojećih.",
    active_tab: 0,
    is_loading: false,
    is_loading_main: true,
    search_text: null,
    responsibilities_list: [],
    headers: [
      {
        text: "Opis odgovornosti",
        value: "description",
        sortable: true,
        align: "left",
      },
    ],
    item: {
      id: 0,
      position_name: null,
      salary_net: null,
      job_description: null,
      education: null,
      languages: null,
      driving_license: null,
      certificates: null,
      department_id: null,
    },
    selected_education: "Izaberite vrstu stručne spreme",
    educations: [
      { text: "Izaberite vrstu stručne spreme", value: null },
      {
        text: "Visoka stručna sprema (VSS)",
        value: "Visoka stručna sprema (VSS)",
      },
      {
        text: "Srednja stručna sprema (SSS)",
        value: "Srednja stručna sprema (SSS)",
      },
      { text: "Zanat", value: "Zanat" },
      { text: "Osnovna škola", value: "Osnovna škola" },
    ],
    title: "Kreiranje nove pozicije",
    visible: false,
  }),
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },
  watch: {
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_item();
          this.get_responsibilities();
        } else {
          this.item = {
            id: 0,
            position_name: null,
            salary_net: null,
            job_description: null,
            education: null,
            languages: null,
            driving_license: null,
            certificates: null,
            department_id: null,
          };
          this.is_loading_main = false;
        }
      },
      immediate: false,
    },
    active_tab: {
      handler() {
        if (this.active_tab == 1 && this.responsibilities_list.length == 0) {
          this.get_responsibilities();
        }
      },
      immediate: false,
    },
  },
  methods: {
    setup_event_listeners() {
      this.$webpageEventBus.$on("wp_department_changed", (selected_item) => {
        this.item.department_id = selected_item.id;
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_department_changed");
    },
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (
          this.item.position_name == null ||
          this.item.position_name.length == 0
        ) {
          has_errors = true;
          reject("Naziv pozicije polje je obavezno");
        }
        if (
          this.item.department_id == null ||
          this.item.department_id.length == 0
        ) {
          has_errors = true;
          reject("Izaberite odjel polje je obavezno");
        }
        if (this.item.salary_net < 0 || this.item.salary_net > 99999999.99) {
          has_errors = true;
          reject("Neto lični dohodak je izvan dozvoljenih granica");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    close_dialog() {
      this.$webpageEventBus.$emit(
        this.close !== null ? this.close : "close_position"
      );
    },
    get_item() {
      this.$http({
        method: "POST",
        url: "/positions/get_position",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      }).then((resp) => {
        let r_item = resp.data.result[0];
        this.is_loading_main = false;
        this.item.id = r_item.id;
        this.item.position_name = r_item.position_name;
        this.item.salary_net = r_item.salary_net;
        this.item.job_description = r_item.job_description;
        this.item.education = r_item.education;
        this.item.languages = r_item.languages;
        this.item.driving_license = r_item.driving_license;
        this.item.certificates = r_item.certificates;
        this.item.department_id = r_item.department_id;
      });
    },
    get_responsibilities() {
      this.is_loading = true;
      this.$http({
        method: "POST",
        url: "/responsibilities/get_responsibilities",
        data: {
          account_id: this.$store.getters.user.account_id,
          position_id: this.id,
        },
      })
        .then((resp) => {
          this.responsibilities_list = resp.data;
          this.selected_responsibilities = this.responsibilities_list.filter(
            (x) => x.is_associated == 1
          );
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    save_item() {
      this.validate()
        .then(() => {
          this.is_btn_loading = true;
          this.item.account_id = this.$store.getters.user.account_id;
          this.$http({
            method: "POST",
            url: "/position/update",
            data: this.item,
          }).then((resp) => {
            if (resp.status == 200) {
              if (!this.item.id) {
                this.$http({
                  method: "POST",
                  url: "positions/check_lastid",
                  data: {
                    account_id: this.$store.getters.user.account_id,
                  },
                }).then((resp) => {
                  if (resp.status == 200) {
                    this.item.id = resp.data[0].id;
                    this.$http({
                      method: "POST",
                      url: "/responsibilities/pos_resp_assoc",
                      data: {
                        position_id: this.item.id,
                        selected_responsibilities: JSON.stringify(
                          this.selected_responsibilities
                        ),
                      },
                    }).then(() => {});
                    this.$webpageEventBus.$emit("show_status", {
                      type: "success",
                      message: "Pozicija je ažurirana",
                      timeout: 2000,
                    });
                    this.$webpageEventBus.$emit("evt_close_position");
                    this.close_dialog();
                    this.$webpageEventBus.$emit("reload_data");
                  } else {
                    this.$webpageEventBus
                      .$emit("show_status", {
                        type: "error",
                        message: resp.data.message,
                        timeout: 4000,
                      })
                      .finally(() => {
                        this.is_loading = false;
                      });
                  }
                });
              } else {
                this.$http({
                  method: "POST",
                  url: "/responsibilities/pos_resp_assoc",
                  data: {
                    position_id: this.item.id,
                    selected_responsibilities: JSON.stringify(
                      this.selected_responsibilities
                    ),
                  },
                });
                this.$webpageEventBus.$emit("show_status", {
                  type: "success",
                  message: "Pozicija je ažurirana",
                  timeout: 2000,
                });
                this.$webpageEventBus.$emit("evt_closeposition");
                this.close_dialog();
                this.$webpageEventBus.$emit("reload_data");
              }
            } else {
              this.$webpageEventBus
                .$emit("show_status", {
                  type: "error",
                  message: resp.data.message,
                  timeout: 4000,
                })
                .finally(() => {
                  this.is_loading = false;
                });
            }
          });
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 4000,
          });
        });
    },
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
};
</script>
<style scoped>
.master_grid {
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  width: 100%;
  padding: 0px 0px 0px;
}

.left_grid {
  color: white;
  display: grid;
  grid-template-rows: 1fr max-content;
  height: 100%;
}
</style>
